import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

export default function SignUp() {
  const { signUp, confirm, oauthSignIn, config } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [zip, setZip] = useState('');
  const [code, setCode] = useState('');
  const [step, setStep] = useState<'form' | 'confirm'>('form');
  const [err, setErr] = useState<string | null>(null);

  async function submit(e: React.FormEvent) {
    e.preventDefault(); setErr(null);
    if (!/^\d{5}$/.test(zip)) return setErr('Zip must be 5 digits.');
    try { await signUp(email, password, zip); setStep('confirm'); }
    catch (e: any) { setErr(e.message); }
  }
  async function confirmSubmit(e: React.FormEvent) {
    e.preventDefault(); setErr(null);
    try { await confirm(email, code); nav('/pending'); }
    catch (e: any) { setErr(e.message); }
  }

  return (
    <div className="container" style={{ maxWidth: 480 }}>
      <div className="card">
        <h2>Create your account</h2>
        {step === 'form' && (
          <form onSubmit={submit}>
            <label>Email</label>
            <input type="email" required value={email} onChange={e => setEmail(e.target.value)} style={{ width: '100%' }} />
            <label style={{ marginTop: 10 }}>Password</label>
            <input type="password" required minLength={12} value={password} onChange={e => setPassword(e.target.value)} style={{ width: '100%' }} />
            <p className="small muted">12+ chars, upper, lower, digit.</p>
            <label style={{ marginTop: 10 }}>Zip code</label>
            <input value={zip} onChange={e => setZip(e.target.value)} maxLength={5} required style={{ width: '100%' }} />
            <p className="small muted">Used to seed your 5-mile map on first login.</p>
            {err && <p className="pill bad" style={{ marginTop: 10 }}>{err}</p>}
            <div className="row" style={{ marginTop: 16, flexWrap: 'wrap' }}>
              <button type="submit">Sign up</button>
              {config?.enableGoogleIdp && (
                <button type="button" className="ghost" onClick={() => oauthSignIn('Google')}>Continue with Google</button>
              )}
              {config?.enableAppleIdp && (
                <button type="button" className="ghost" onClick={() => oauthSignIn('SignInWithApple')}>Sign in with Apple</button>
              )}
            </div>
            <p className="small muted" style={{ marginTop: 16 }}>
              Accounts are reviewed by an admin before sign-in is enabled.
            </p>
          </form>
        )}
        {step === 'confirm' && (
          <form onSubmit={confirmSubmit}>
            <p>We sent a 6-digit code to <b>{email}</b>.</p>
            <label>Verification code</label>
            <input value={code} onChange={e => setCode(e.target.value)} required maxLength={6} style={{ width: '100%' }} />
            {err && <p className="pill bad" style={{ marginTop: 10 }}>{err}</p>}
            <button type="submit" style={{ marginTop: 14 }}>Verify</button>
          </form>
        )}
      </div>
    </div>
  );
}
